<!-- 器械采购订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :rules="$common.getFormItemRules(formOneValue, sendDataInfo)">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 日期 -->
                                                    <df-date class="form_codition" v-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                                                        :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)"></df-date>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                                                        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input class="form_codition" @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)"
                                                            @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                            :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                            :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 账期 -->
                                                    <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :maxlength="$store.state.inputLength"></el-input>
                                                    <!-- string类型 -->
                                                    <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" v-else
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                        :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay' || formOneValue.entityField == 'isMag'">{{
                                                        sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"
                                                    }}</span>
                                                    <span
                                                        v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <div>
                                        <el-form :inline="true" size="mini">
                                            <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                                                <el-button v-if="actionData.orderType!='UDI'" type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                                    新增</el-button>
                                                <el-button v-if="actionData.orderType!='UDI'" type="primary" size="mini" @click="deleteDetails()">删除
                                                </el-button>
                                                <el-button v-if="actionData.orderType!='UDI'" type="primary" size="mini" @click="copyDetails()">复制
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="lookLicence()">查看证照
                                                </el-button>
                                                <el-button v-if="tabForm[0].isExtract==1" @click="openExtSearch('629899519725569')" size="mini" type="primary">提取外部订单</el-button>
                                                <el-button @click="openExtSearch('949599709200712')" size="mini" type="primary">提取合同</el-button>
                                                <el-button @click="openExtSearch('375355040796672')" size="mini" type="primary">提取采购计划</el-button>
                                                <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                                <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                                <el-button v-if="actionData.orderType=='UDI'" @click="UDIclick('sendDataInfo')" size="mini" type="primary">UDI扫码</el-button>
                                                <el-dropdown style="margin-left: 5px;" v-if="$store.state.btnlist" trigger="click">
                                                    <el-button type="primary">
                                                        辅助功能<i class="el-icon-arrow-down el-icon--right"></i>
                                                    </el-button>
                                                    <template #dropdown>
                                                        <el-dropdown-menu slot="dropdown">
                                                            <el-dropdown-item v-for="(item, index) in JSON.parse($store.state.btnlist)" :key="index" @click.native="Historical(item.mdSource, item.mdName)">{{
                                                                    item.mdName }}</el-dropdown-item>
                                                        </el-dropdown-menu>
                                                    </template>
                                                </el-dropdown>

                                                <el-link  v-if="actionData.orderType!='UDI'" :underline="false" type="danger" style="margin-left: 10px;">
                                                    (Alt+F1：新增明细</el-link>
                                                <el-link  v-if="actionData.orderType!='UDI'" :underline="false" type="danger" style="margin-left: 10px;">
                                                    Alt+F2：删除明细)</el-link>
                                            </div>
                                            <el-table :key="tableKey" size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.pisOrderDetail" :row-class-name="rowClassName" :row-style="rowStyle"
                                                @row-click="clickEvent" @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                                                <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                    <template slot-scope="scope">
                                                        <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                            <i class="el-icon-thumb"></i>
                                                        </el-radio>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                                <template v-for="(formOneValue, formOneKey) in mxForm.jurconfigform">
                                                    <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :key="formOneKey"
                                                        v-if="formOneValue.isShow == 1">
                                                        <template slot-scope="scope">
                                                            <el-input @mousewheel.native.prevent @clear="clear(scope.$index, formOneValue.entityField)" v-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2" clearable
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)"
                                                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                                <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                                    icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                                </el-button>
                                                            </el-input>
                                                            <!-- 数量 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" @blur="blurwoadPnumber(scope.$index)"
                                                                @input="calculatePrice(5, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'psodPacknum' && dataActionBox.actionType != 2&&actionData.orderType!='UDI'" type="number"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index].psodPacknum">
                                                            </el-input>
                                                            <!-- 含税价 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" @input="calculatePrice(2, scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2" :maxlength="$store.state.inputLength" type="number"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 含税金额 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" @input="calculatePrice(4, scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2" :maxlength="$store.state.inputLength" type="number"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 折前价格 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(5, scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'disPreprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 价格策略 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField.indexOf('levePrice')!=-1  && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 含税原价 -->
                                                            <el-input @mousewheel.native.prevent @input="calculatePrice(6, scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'orPsprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 不含税原价 -->
                                                            <el-input @mousewheel.native.prevent @input="calculatePrice(7, scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'orPrice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 备注 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField == 'psodRemark' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <span v-else-if="formOneValue.isRift == 1">
                                                                <a @click="toDetail(sendDataInfo.pisOrderDetail[scope.$index][formOneValue.riftField])">
                                                                    {{
                                                                    sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]
                                                                }}</a>
                                                            </span>
                                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                                <span v-if="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                                    {{ $common.getLocalTime(sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]) }}
                                                                </span>
                                                            </span>
                                                            <span v-else>{{sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]}}</span>
                                                        </template>
                                                    </el-table-column>
                                                </template>
                                            </el-table>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <!-- 底部 -->
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="showSmPustateDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="[{level: 0, data: smPustateRemark}]" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showSmPustateDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :isRepetition="isRepetition" :isRepetitionList="isRepetitionList" :isProp="'bgmId'" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :interceptFlag="interceptFlag" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel" :parentSearchData="importObj">
            </initDataUpload>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog title="维护控销" v-if="showControlPin" :visible.sync="showControlPin" width="70%" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <maintenanceControlPinAciton :mainFormPin="mainFormPin" :actionType="dataActionBox.actionType" :controlGoodTempAdds="controlGoodTempAdds" ref="maintenanceControlPinAciton" @controlPin="getcontrolPin">
            </maintenanceControlPinAciton>
        </el-dialog>
        <component :is="currentComponent" :ref="currentComponent"></component>
        <el-dialog class="dialogBox" title="UDI扫码" v-if="UDIshow" :visible.sync="UDIshow" width="95vw" :modal-append-to-body='true' :append-to-body="true" top="10px">
            <purchaseUDIscanCode :actionData="UDIobj" @clearClick="clearClick"></purchaseUDIscanCode>
        </el-dialog>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import maintenanceControlPinAciton from "@/components/maintenanceControlPinAciton.vue";
import purchaseUDIscanCode from "../udi/purchaseUDIscanCode.vue";
// import VTabs from '../byComponents/vTabs.vue';
export default {
    name: "puInstrumentOrderAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        maintenanceControlPinAciton,
        purchaseUDIscanCode,
        // VTabs
    },
    data() {
        //这里存放数据
        return {
            currentComponent: "",
            //-----------------------------------
            showDialog: false,
            dialogList: [],
            showDialog1: false,
            flags: false,
            flag: -1,
            mxHeight: 0,
            guaranteeBeginDay: "",
            detailRules: false, //规则
            ruleDisabled: false,
            selectDataTable: false,
            showControlPin: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {
                bgmId: "",
                bgmName: "",
                inRate: 0,
                money: 0,
                psodPacknum: 0,
                price: 0,
                psodPsdvolume: 0,
                psodPslowerlimit: 0,
                psmoney: 0,
                psodPsnvolume: 0,
                psprice: 0,
                // 进项税率
                inRate: 0,
                psodPsupperlimit: 0,
                psodReserves1: "",
                psodReserves2: "",
                psodReserves3: "",
                psodReserves4: "",
                psodReserves5: "",
                psodReserves6: "",
                psomId: "",
                pspdId: "",
                stId: "",
                depId: "",
                lastPuprice: "", //	最后一次采购价
                spec: "",
                manufacturer: "",
                scopeName: "",
                placeorigin: "",
                mne: "",
                bgiAppnumber: "",
                pieceNum: "", //件数
            },
            selectedDetailsIndex: 0,
            value1: "",
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            salesmanList: [],
            editDateilsIndex: "",
            exId: "",
            ppId: "orderId",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            interceptFlag: false,//是否提取拦截
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            parentSearchData: {
                smId: "",
                orderType: 1, //	订单类型0.药品1.器械
            },
            isLoaded: false,
            orderId: "",
            printsouce: "",
            seIndex: 0, //选中索引
            isBuyer: 0,
            tabForm: [], // tab循环的主表单
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            mxForm: [],
            footForm: [],
            selectedRow: [],
            mainFormPin: [], //维护控销数据
            controlGoodTempAdds: [], //
            tableKey: 0,
            stNameFlag: false,//判断库房是在表单里选择的还是明细里选择的
            isRepetitionList: [],
            isRepetition: false,
            importShow: false,
            importType: "",
            url: "",
            smPustate: null,
            smPustateRemark: "",
            showSmPustateDialog: false,
            importObj: {
                formId: "",
                salesId: "",
                unitId: "",
            },
            setField: "",
            UDIshow: false,
            UDIobj: {},
            UDIlist: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.pisOrderDetail": {
            handler: function (newValue, oldValue) {
                this.ruleDisabled = newValue.length > 0 ? true : false;
                // 初始化总计值
                let totalMoney = 0;
                let totalNumber = 0;
                let totalCount = newValue.length;

                // 预定义需要处理的字段数组
                const priceFields = ['disPreprice', ...Array.from({ length: 9 }, (_, i) => `levePrice${i + 1}`)];

                newValue.forEach((item, keys) => {
                    // 批量处理价格字段
                    priceFields.forEach(field => {
                        if (item.hasOwnProperty(field)) {
                            this.$set(item, field, this.$common.updataNum(field, item)[field]);
                        }
                    });

                    // 处理特定字段
                    this.$set(item, 'psodPacknum', this.$common.updataNum('psodPacknum', item).psodPacknum);
                    this.$set(item, 'psprice', this.$common.updataNum('psprice', item).psprice);

                    if (item.orPsprice !== undefined) {
                        this.$set(item, 'orPsprice', this.$common.updataNum('orPsprice', item).orPsprice);
                    }
                    if (item.orPrice !== undefined) {
                        this.$set(item, 'orPrice', this.$common.updataNum('orPrice', item).orPrice);
                    }

                    // 验证并修正负值
                    if (item.psodPacknum < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].psodPacknum = 0;
                    } else if (item.price === '' || item.price < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].price = 0;
                    } else if (item.price < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].price = 0;
                    }
                    if (item.money < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].money = 0;
                    }
                    if (item.psprice < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].psprice = 0;
                    }
                    if (item.psmoney < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].psmoney = 0;
                    }

                    // 累加计算总值
                    totalMoney = this.$common.getDecimalInfo(3, NP.plus(totalMoney, item.psmoney));
                    totalNumber = this.$common.getDecimalInfo(1, NP.plus(totalNumber, item.psodPacknum));
                });

                // 一次性更新总计信息
                this.sendDataInfo.totalMoney = totalMoney;
                this.sendDataInfo.totalNumber = totalNumber;
                this.sendDataInfo.totalCount = totalCount;

                this.mainFormPin = this.sendDataInfo;
                this.mainFormPin = JSON.parse(JSON.stringify(this.mainFormPin));
            },
            deep: true,
        },
        "sendDataInfo.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.smId = "";
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.salesId = "";
                    this.parentSearchData.smId = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.isPay": {
            handler: function (newValue, oldValue) {
                if (newValue == 0) {
                    this.sendDataInfo.sbiName = "";
                    this.sendDataInfo.sbiId = "";
                    this.sendDataInfo.sbiNumber = "";
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "sbiName" ||
                            item.entityField == "sbiNumber"
                        ) {
                            item.isShow = 0;
                        }
                    });
                } else {
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "sbiName" ||
                            item.entityField == "sbiNumber"
                        ) {
                            item.isShow = 1;
                        }
                    });
                }
                this.$forceUpdate();
            },
            deep: true,
        },
        "parentSearchData.smId": {
            handler: function (newValue, oldValue) {
            },
            deep: true,
        },
        // showDialog() {
        //     if (!this.showDialog && this.seType == "bgmName") {
        //         this.tableNextFocus(this.seType, this.seIndex)
        //     }
        // },
    },
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.pisOrderDetail.push(...list)
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/pisplanorder/downPisDetailExcel`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'exportPisDetail'
                    this.url = 'pisplanorder/exportPisDetail'
                    this.importObj.formId = this.mxForm.jciId //表单ID
                    this.importObj.unitId = this.sendDataInfo.smId //单位ID
                    this.importObj.salesId = this.sendDataInfo.salesId //对方业务员ID
                    this.importShow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        blurwoadPnumber(index) {
            var info = this.sendDataInfo.pisOrderDetail[index];
            this.sendDataInfo.pisOrderDetail[index].psodPacknum = this.$common.getDecimalInfo(
                1,
                info.psodPacknum
            );
        },
        async blur(focusField, index, ownField, title) {
            setTimeout(async () => {//失去焦点事件和点击事件冲突addDetail
                if (title == 'blur') {
                    this.blurData = title
                } else {
                    this.blurData = ''
                }
                console.log(this.flags);
                if (this.flags) {
                    this.flags = false
                    return
                }
                this.fField = focusField
                this.seIndex = index
                this.seType = ownField
                let params = {
                    "formId": this.formDataList[1].jciId,
                    "num": '',
                    "psprice": ''
                }
                if (ownField == 'psodPacknum') {
                    params.num = this.sendDataInfo.pisOrderDetail[index][ownField]
                } else if (ownField == 'psprice') {
                    params.psprice = this.sendDataInfo.pisOrderDetail[index][ownField]
                }
                if (ownField) {
                    await this.$http.interceptPuNumPsPrice(params).then(res => {

                        this.flag = -1
                        this.dialogList = []
                        if (res.result != null && res.result.length > 0) {
                            res.result.forEach(item => {
                                this.dialogList.push(item)
                            })
                            this.flag = this.dialogList.findIndex(item => item.level == 0)

                        } else {
                            console.log(this.sendDataInfo.pisOrderDetail[index][ownField]);
                            if (this.sendDataInfo.pisOrderDetail[index][ownField] != 0) {
                                this.tableNextFocus(this.fField, this.seIndex);
                            }
                        }
                        console.log(this.flag)
                        if (this.flag == 0) this.showDialog1 = true
                        if (this.flag != -1) {
                            this.$nextTick(() => {
                                // document.getElementById("qrBtn")?.focus();
                                if (title != 'blur') {
                                    this.flags = true
                                }
                                this.sendDataInfo.pisOrderDetail[index][ownField] = 0
                                this.$refs[ownField][index].blur()
                            })
                        }
                    })

                }
            }, 150)
        },
        intercept() {
            this.showDialog1 = false

            if (this.flag == -1) {
                this.tableNextFocus(this.fField, this.seIndex);
            } else {
                this.$nextTick(() => {
                    this.$refs[this.seType][this.seIndex].focus()
                })
            }
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        clear(index, field) {
            this.tableKey++
            this.$nextTick(() => {
                this.tableNextFocus(field, index)
            })
        },
        Historical(url, title) {
            this.currentComponent = url
            var historicalOrder = {
                smName: "",
                smId: "",
                bgmName: "",
                bgmId: "",
            }
            if (this.currentComponent == 'historicalOrders') {
                historicalOrder.smName = this.sendDataInfo['smName']
                historicalOrder.smId = this.sendDataInfo['smId']

            }
            if (this.sendDataInfo['pisOrderDetail'].length > 0) {
                historicalOrder.bgmId = this.sendDataInfo['pisOrderDetail'][this.selectedDetailsIndex].bgmId
                historicalOrder.bgmName = this.sendDataInfo['pisOrderDetail'][this.selectedDetailsIndex].bgmName
            }
            this.$nextTick(() => {
                this.$refs[this.currentComponent].openBox(historicalOrder, title)
            })
        },
        //触发提取
        openExtSearch(id) {
            this.interceptFlag = false
            if (id == '375355040796672') {
                this.ppId = 'prmId'
            } else if (id == '949599709200712') {
                this.interceptFlag = true
                this.ppId = 'conmId'
            } else if (id == '629899519725569') {
                this.ppId = 'orderId'
            }
            this.exId = id;
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            if (val != "" || val != undefined) {
                if (this.sendDataInfo.smId && this.sendDataInfo.smId !== val.smId) return this.$message({ message: "请提取相同供货单位的单据", type: "error", });
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        if (this.exId == '949599709200712') {
                            this.sendDataInfo.pisOrderDetail = [];
                            this.sendDataInfo.pisOrderDetail = val.arrlistbychen;  //要求能看明细但不提取
                        } else {
                            this.sendDataInfo.pisOrderDetail = val.arrlistbychen;
                            this.sendDataInfo.pisOrderDetail.forEach((v, i) => {
                                this.calculatePrice(2, i)
                            })
                        }
                    } else {
                        if (key == 'opmName' && val[key] == null || key == 'depName' && val[key] == null || key == 'depId' && val[key] == null || key == 'opmId' && val[key] == null) {
                            this.sendDataInfo[key] = this.sendDataInfo[key]
                        } else if (val[key] == null || val[key] === "") {
                        } else {
                            this.sendDataInfo[key] = val[key];
                        }
                        this.sendDataInfo.totalMoney = 0;
                        this.sendDataInfo.totalNumber = 0;
                        this.sendDataInfo.totalCount = 0;
                    }
                }
                if (!val.salesName || !val.salesId || !val.recName || !val.recId) {
                    this.$http.queryDefaultSales({
                        ids: [val.smId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            for (const key in res.result) {
                                if (!this.sendDataInfo[key]) {
                                    this.sendDataInfo[key] = res.result[key] || "";
                                }
                            }
                        }
                    })
                }
                this.DialogExtract = false;
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]);
                    this.nextFocus(0)
                })
            }
        },
        // 获取控销保存数据
        async getcontrolPin(value) {
            this.controlGoodTempAdds = value
            if (this.controlGoodTempAdds.length > 0) {
                this.showControlPin = false
            }
        },
        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.smId == "") {
                return this.$message({
                    message: "请先选择供货单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.smId);
        },
        UDIclick(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {

                    //------------
                    this.UDIobj = {
                        data: this.sendDataInfo,
                        UDIlist: this.UDIlist || []
                    }
                    this.UDIshow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        clearClick(flag, val, list) {
            if (flag) {
                if (list.length > 0) {
                    this.UDIlist = list
                }else{
                    this.UDIlist = []
                }
                this.sendDataInfo.pisOrderDetail = [];
                const numberList = this.mxForm.jurconfigform.filter((item) => item.fieldType == "number").map((item) => item.entityField);
                val.forEach((item, index) => {
                    item.psodPacknum = item.psodPacknum || item.woadPnumber || 0
                    item.psmoney = item.psmoney || 0
                    item.money = item.money || 0
                    this.sendDataInfo.pisOrderDetail.push({});
                    for (const key in this.detaislDataInfo) {
                        const index1 = numberList.findIndex(items => items == key);
                        if (index1 != -1 && !item[key]) {
                            this.$set(this.sendDataInfo.pisOrderDetail[index], key, 0);
                        } else {
                            this.$set(this.sendDataInfo.pisOrderDetail[index], key, item[key] != undefined && item[key] != null ? item[key] : "");
                        }
                    }
                    var setField = [];
                    if (this.setField) {
                        setField = this.setField.split(",");
                        setField.forEach((item1) => {
                            if (item1 == "psprice") {
                                this.$set(this.sendDataInfo.pisOrderDetail[index], "psprice", item.psprice || 0);
                            } else {
                                this.$set(this.sendDataInfo.pisOrderDetail[index], "psprice", item.psprice || 0);
                            }
                        });
                    } else {
                        this.$set(this.sendDataInfo.pisOrderDetail[index], "psprice", item.psprice || 0);
                    }
                    this.calculatePrice(5, index)
                });
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    if (refsElTable && this.sendDataInfo.pisOrderDetail.length > 0) {
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]);
                    }
                })
            }
            this.UDIshow = false
        },
        closeChild() {
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.pisOrderDetail.length > 0) {
                }
                if (this.actionData.orderType != 'UDI') {
                    this.addDetail("sendDataInfo");
                }
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.inputel[aindex].focus();
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },

        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == "keydown") {
                if (this.actionData.orderType != 'UDI') {
                    this.addDetail("sendDataInfo");
                }
                if (this.sendDataInfo.pisOrderDetail[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    return;
                }
                // if(this.blurData != 'blur'){
                //     this.addDetail("sendDataInfo");
                // }
                return;
            }
            if (field) {
                this.$refs[field][index].focus();
            }
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log(this.actionData, "打印选中数据");
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId);
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex);
            });
        },
        // 表格赋值字段
        mxParamValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], item, val[item])
            });
            this.$nextTick(() => {
                this.tableKey++
                this.tableNextFocus(this.seType, this.seIndex);
            });
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        verifySmPustate(val) {
            if (val.smPustate == 0) {
                this.$set(this, 'smPustate', val.smPustate)
                this.$set(this, 'smPustateRemark', `该供应商已停用，${val.smPustateRemark}`)
                this.$set(this, 'showSmPustateDialog', true)
                return false
            }
            return true
        },
        //提取返回
        changeInputModel(val) {
            console.log("返回val", val, this.seType);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                addEventListener("keyup", this.keyUp); //创建监听键盘事件
                if (val.depId) {
                    this.sendDataInfo.depId = val.depId;
                    this.sendDataInfo.depName = val.depName;
                }
                if (this.seType == "bgmName") {
                    var bgiTypeArr = [];
                    var bgmIds = []
                    var repeatBgmId = []
                    this.sendDataInfo.pisOrderDetail.forEach((v) => {
                        if (v.bgmName != '' && v.bgmId != "") {
                            bgiTypeArr.push(v.bgiType);
                            repeatBgmId.push(v.bgmId);
                        }
                    });
                    if (Array.isArray(val)) {
                        val.forEach(item => {
                            bgmIds.push(item.bgmId)
                            bgiTypeArr.push(item.bgiType)
                            repeatBgmId.push(item.bgmId);
                        })
                    } else {
                        bgiTypeArr.push(val.bgiType)
                        bgmIds = [val.bgmId]
                        repeatBgmId.push(val.bgmId);
                    }
                    this.$http
                        .checkPurchasingScope({
                            //校验明细商品
                            formId: this.mxForm.jciId, //表单ID
                            unitId: this.sendDataInfo.smId, //单位ID
                            bgmId: bgmIds, //商品id
                            repeatBgmId: repeatBgmId,//重复商品id
                            ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, //组织ID
                            salesId: this.sendDataInfo.salesId, //对方业务员ID
                            bgiTypes: bgiTypeArr, //药品类型
                        })
                        .then((res) => {
                            if (res && res.status == 200) {
                                this.flag = -1
                                this.dialogList = []
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                if (this.dialogList != null && this.dialogList.length > 0) {
                                    this.flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (this.flag == -1) {
                                    if (Array.isArray(val)) {
                                        this.bgmSelect(val)
                                        return
                                    }
                                    for (let key in val) {
                                        this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                                            val[key];
                                    }
                                    this.sendDataInfo.pisOrderDetail[
                                        this.seIndex
                                    ].psodPsdvolume = val.rjXl;
                                    this.sendDataInfo.pisOrderDetail[
                                        this.seIndex
                                    ].psodPsnvolume = val.stockNum;
                                    this.sendDataInfo.pisOrderDetail[
                                        this.seIndex
                                    ].psodPsupperlimit = val.limdHighnum;
                                    this.sendDataInfo.pisOrderDetail[
                                        this.seIndex
                                    ].psodPslowerlimit = val.limdLownum;
                                    if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                        this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                        this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                    }
                                    if (!this.dialogList.length) {
                                        this.tableNextFocus(this.fField, this.seIndex);
                                    }
                                }
                            } else if (res && res.status == 300) {
                                this.lineMessageBox(res);
                                for (let key in val) {
                                    this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                                        val[key];
                                }
                                this.sendDataInfo.pisOrderDetail[
                                    this.seIndex
                                ].psodPsdvolume = val.rjXl;
                                this.sendDataInfo.pisOrderDetail[
                                    this.seIndex
                                ].psodPsnvolume = val.stockNum;
                                this.sendDataInfo.pisOrderDetail[
                                    this.seIndex
                                ].psodPsupperlimit = val.limdHighnum;
                                this.sendDataInfo.pisOrderDetail[
                                    this.seIndex
                                ].psodPslowerlimit = val.limdLownum;
                                console.log(this.seType, this.seIndex);
                                if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                }
                                this.tableNextFocus(this.seType, this.seIndex);
                            } else {

                                this.lineMessageBox(res);
                                this.$set(
                                    this.sendDataInfo.pisOrderDetail,
                                    this.seIndex,
                                    JSON.parse(JSON.stringify(this.detaislDataInfo))
                                );
                                if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                }
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            for (let key in this.sendDataInfo.pisOrderDetail[
                                this.seIndex
                            ]) {
                                this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                                    "";
                            }
                            if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                            }
                        });
                } else if (this.seType == "smName") {
                    if (!this.verifySmPustate(val)) return
                    this.$http
                        .checkVendorLicense({
                            //校验购进单位
                            formId: this.formDataList[0].jciId, //表单ID
                            unitId: val.smId, //单位ID
                        })
                        .then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                let flag = -1
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    this.parentSearchData.smId = val.smId;
                                    this.sendDataInfo.smName = val.smName;
                                    this.sendDataInfo.smId = val.smId;
                                    this.$http.queryDefaultSales({
                                        ids: [val.smId]
                                    }).then((res) => {
                                        if (res && res.status == 200) {
                                            var valObj = {
                                                ...val,
                                                ...res.result,
                                            }
                                            if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                                this.$http.checkSalesLicense({
                                                    //校验供应商业务员
                                                    formId: this.formDataList[0].jciId, //表单ID
                                                    salesId: valObj.salesId, //业务员ID
                                                }).then((res) => {
                                                    if (res && res.status == 200) {
                                                        let flag = -1;
                                                        if (res.result != null && res.result.length > 0) {
                                                            res.result.forEach(item => {
                                                                this.dialogList.push(item)
                                                            })
                                                            flag = this.dialogList.findIndex(
                                                                (item) => item.level == 0
                                                            );
                                                            this.showDialog = true;
                                                        }
                                                        if (flag == -1) {
                                                            this.paramValue(valObj);
                                                        }
                                                    } else {
                                                        this.lineMessageBox(res);

                                                        return false;
                                                    }
                                                }).catch((rej) => {
                                                    this.lineMessageBox(rej);
                                                });
                                            } else {
                                                this.paramValue(val);
                                            }
                                        } else {
                                            this.paramValue(val);
                                        }
                                    }).catch((rej) => {
                                        this.lineMessageBox(rej);
                                    });
                                } else {
                                    this.showDialog = true
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.parentSearchData.smId = "";
                                this.clearValue();
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            this.parentSearchData.smId = "";
                            this.clearValue();
                        });
                } else if (this.seType == "salesName") {
                    this.$http
                        .checkSalesLicense({
                            //校验供应商业务员
                            formId: this.formDataList[0].jciId, //表单ID
                            salesId: val.salesId, //业务员ID
                        })
                        .then((res) => {
                            if (res && res.status == 200) {
                                let flag = -1
                                this.dialogList = []
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    this.paramValue(val);
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.clearValue();
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            this.clearValue();
                        });
                } else if (this.seType == "stName") {
                    if (this.stNameFlag) {
                        this.mxParamValue(val);
                    } else {
                        this.sendDataInfo.stId = val.stId
                        this.sendDataInfo.stName = val.stName

                        this.paramValue(val);
                        if (this.sendDataInfo.pisOrderDetail.length > 0) {
                            this.sendDataInfo.pisOrderDetail.forEach(item => {
                                item.stName = val.stName
                                item.stId = val.stId
                            })
                        } else {
                            this.$nextTick(() => {
                                this.nextFocus(this.seIndex);
                            });
                        }
                    }
                } else {
                    this.paramValue(val);
                }
                if (this.seType != "bgmName" && this.seType != "stName") {
                    this.changeFocus();
                }
            }
        },
        bgmSelect(val) {
            if (this.sendDataInfo.pisOrderDetail && this.sendDataInfo.pisOrderDetail.length > 0) {
                var mx = JSON.parse(JSON.stringify(val))
                this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                    if (item.bgmId == '' || item.bgmName == '') {
                        this.sendDataInfo.pisOrderDetail.splice(index, 1)
                    }
                })
                mx.forEach((item) => {
                    this.sendDataInfo.pisOrderDetail.push({})
                    for (const key in this.detaislDataInfo) {
                        this.$set(this.sendDataInfo.pisOrderDetail[this.sendDataInfo.pisOrderDetail.length - 1], key, item[key] != undefined && item[key] != null ? item[key] : '')
                        if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                            this.$set(this.sendDataInfo.pisOrderDetail[this.sendDataInfo.pisOrderDetail.length - 1], 'stName', this.sendDataInfo.stName);
                            this.$set(this.sendDataInfo.pisOrderDetail[this.sendDataInfo.pisOrderDetail.length - 1], 'stId', this.sendDataInfo.stId);
                        }
                    }
                })
            } else {
                this.sendDataInfo.pisOrderDetail = []
                val.forEach((item, index) => {
                    this.sendDataInfo.pisOrderDetail.push({})
                    for (const key in this.detaislDataInfo) {
                        this.$set(this.sendDataInfo.pisOrderDetail[index], key, item[key] != undefined && item[key] != null ? item[key] : '')
                        if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                            this.$set(this.sendDataInfo.pisOrderDetail[index], 'stName', this.sendDataInfo.stName);
                            this.$set(this.sendDataInfo.pisOrderDetail[index], 'stId', this.sendDataInfo.stId);
                        }
                    }
                })
            }
            this.selectedDetailsIndex = this.sendDataInfo.pisOrderDetail.length - 1
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag) {
            setTimeout(() => {
                this.showDialog = false
            }, 16.7)
            if (type == "salesName" || type == "caiAddress" || type == "recName" || type == "sbiName") {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.parentSearchData[type] = this.sendDataInfo[type];
            if (type == "stName") {
                if (flag) {
                    this.stNameFlag = flag
                    this.parentSearchData.stName = this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex].stName;
                } else {
                    this.stNameFlag = false
                    this.parentSearchData.stName = this.sendDataInfo.stName;
                }
            }

            this.isRepetition = false
            if (type == "bgmName") {
                this.isRepetition = true
                this.isRepetitionList = this.sendDataInfo.pisOrderDetail
                this.parentSearchData.stId = this.sendDataInfo.stId;
                this.parentSearchData.cmId = this.sendDataInfo.cmId;
                this.parentSearchData.coId = this.sendDataInfo.coId;
                this.parentSearchData.bgmName = this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName;
                if (this.parentSearchData.bgmName) {
                    let fh = 0
                    if (this.parentSearchData.bgmName.indexOf(',') != -1) {
                        fh = ','
                    } else if (this.parentSearchData.bgmName.indexOf('，') != -1) {
                        fh = '，'
                    }
                    if (fh !== 0) {
                        const str = this.parentSearchData.bgmName
                        const list = str.split(fh)
                        this.parentSearchData.bgmName = list[0] || ''
                        this.parentSearchData.manufacturer = list[1] || ''
                    } else {
                        this.parentSearchData.manufacturer = ''
                    }
                } else {
                    this.parentSearchData.bgmName = ''
                    this.parentSearchData.manufacturer = ''
                }
                return;
            } else if (type == "salesName") {
                this.parentSearchData.smId = this.sendDataInfo.smId;
            }
            if (type == "payMethod") {
                this.parentSearchData.diValue = this.sendDataInfo.payMethod
            }
            if (type == "settleMethod") {
                this.parentSearchData.diValue = this.sendDataInfo.settleMethod
            }


        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        //新增明细
        addDetail(sendDataInfo) {
            console.log("123")
            var flag = false
            console.log(this.sendDataInfo.pisOrderDetail)
            if (this.sendDataInfo.pisOrderDetail.length > 0) {
                this.sendDataInfo.pisOrderDetail.forEach(item => {
                    if (item.bgmId == "") {
                        flag = true
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                })
            }
            if (flag) {
                return
            }
            console.log("123*************")
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.pisOrderDetail.push(
                        JSON.parse(JSON.stringify(this.detaislDataInfo))
                    );
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.pisOrderDetail.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        detailsAction(cate = 0) {
            if (cate == 0) {
                this.editDateilsIndex = "";
                return false;
            }

            var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
            if (dataInfo.psodPacknum <= 0) {
                this.$message({
                    message: "请填写采购数量",
                    type: "error",
                });
                return false;
            }
            if (this.editDateilsIndex !== "") {
                this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1);
            }
            this.sendDataInfo.pisOrderDetail.push(dataInfo);
            this.editDateilsIndex = "";
        },
        // 计算价格
        calculatePrice(cate, index) {
            const info = this.sendDataInfo.pisOrderDetail[index];

            // 安全检查，确保数据有效性
            if (info.psodPacknum <= 0) {
                this.$message({
                    message: "请先填写采购数量",
                    type: "error",
                });
            }

            // 缓存常用变量，避免重复访问
            const details = this.sendDataInfo.pisOrderDetail[index];
            const quantity = parseFloat(info.psodPacknum) || 0;
            const taxRate = parseFloat(info.inRate) || 0;
            const price = parseFloat(info.price) || 0;
            const psprice = parseFloat(info.psprice) || 0;
            const psmoney = parseFloat(info.psmoney) || 0;

            // 创建税率计算辅助函数
            const calculateTaxFactor = () => NP.plus(1, NP.divide(taxRate, 100));
            const calculateTaxAdjustedPrice = (basePrice) => this.$common.getDecimalInfo(2, NP.times(basePrice, calculateTaxFactor()));
            const calculateBaseFromTaxed = (taxedValue) => this.$common.getDecimalInfo(3, NP.divide(taxedValue, calculateTaxFactor()));

            switch (cate) {
                case 1: // 单价计算
                    // 计算含税价格 单价+单价*税率/100
                    const taxAdjustedPrice = calculateTaxAdjustedPrice(price);
                    details.psprice = this.$common.getDecimalInfo(2, taxAdjustedPrice);
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (details.orPsprice || 0)), 100));
                    }
                    // 计算金额 单价*数量
                    details.money = this.$common.getDecimalInfo(3, NP.times(price, quantity));
                    // 计算含税金额 含税价格*数量
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(taxAdjustedPrice, quantity));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    break;
                case 2: // 含税价格计算
                    // 计算含税金额 含税价格*数量
                    details.psmoney = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(psprice, quantity));
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((info.psprice || 0), (details.orPsprice || 0)), 100));
                    }
                    // 计算金额 含税金额/(税率/100+1)
                    const midmoney = calculateBaseFromTaxed(details.psmoney);
                    details.money = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, quantity));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    break;
                case 3: // 通过总金额计算
                    // 计算单价  总金额 / 数量
                    const calculatedPrice = quantity ? this.$common.getDecimalInfo(2, NP.divide(info.money, quantity)) : 0;
                    details.price = calculatedPrice;
                    // 计算含税价格 单价+单价*税率/100
                    const taxAdjustedPrice2 = calculateTaxAdjustedPrice(calculatedPrice);
                    details.psprice = this.$common.getDecimalInfo(3, taxAdjustedPrice2);
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (details.orPsprice || 0)), 100));
                    }
                    // 计算含税金额 含税价格*数量
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(taxAdjustedPrice2, quantity));
                    // 计算整件数量
                    details.wholeNum = Math.floor(NP.divide(quantity, Number(info.packingSpec)));
                    //计算零散数量
                    details.scatNum = NP.minus(quantity, NP.times(details.wholeNum, Number(info.packingSpec)));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    break;
                case 4: // 通过含税金额计算
                    // 计算总金额 含税金额/(税率/100+1)
                    const midmoney2 = calculateBaseFromTaxed(psmoney);
                    details.money = this.$common.getDecimalInfo(3, midmoney2);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney2, quantity));
                    // 计算含税价格  含税金额 / 数量
                    details.psprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(psmoney, quantity));
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (details.orPsprice || 0)), 100));
                    }
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(psmoney, details.money));
                    break;
                case 6: //含税原价
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                    details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                    details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide((details.orMoney || 0), quantity));
                    details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    break;
                case 7: //不含税原价
                    // 计算含税原价 不含税原价+不含税原价*税率/100
                    details.orPsprice = calculateTaxAdjustedPrice(info.orPrice);
                    //计算含税原金额
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((details.orPsprice || 0), quantity));
                    // 计算不含税原金额
                    details.orMoney = this.$common.getDecimalInfo(3, NP.times((info.orPrice || 0), quantity));
                    //计算折扣率
                    details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (details.orPsprice || 0)), 100));
                    break;
                default:
                    // 通过数量计算
                    // 计算含税金额 含税价格*数量
                    const midmoney3 = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, quantity));
                    details.psmoney = this.$common.getDecimalInfo(3, midmoney3);
                    // 计算总金额 含税金额/(税率/100+1)
                    details.money = calculateBaseFromTaxed(details.psmoney);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity));
                    // 计算整件数量
                    details.wholeNum = Math.floor(NP.divide(quantity, Number(info.packingSpec)));
                    //计算零散数量
                    details.scatNum = NP.minus(quantity, NP.times(details.wholeNum, Number(info.packingSpec)));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                        details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                        details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide((details.orMoney || 0), quantity));
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((info.psprice || 0), (details.orPsprice || 0)), 100));
                    }
                    // 计算件数 采数/包装单位
                    if (
                        parseFloat(info.packingSpec) <= 0 ||
                        info.packingSpec == ""
                    ) {
                        details.pieceNum = 0;
                    } else {
                        details.pieceNum = this.$common.getDecimalInfo(1, NP.divide(quantity, info.packingSpec));
                    }
                    break;
            }
            details.disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0));
        },
        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    // this.$parent.getDataList()
                    this.init();
                    this.$refs[sendDataInfo].resetFields();
                    this.mainFormPin = []
                    sessionStorage.removeItem('setPin1')
                    sessionStorage.removeItem('allAndself')
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisOrderAuxinf") {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            // this.sendDataInfo.psomBuydate = this.$moment().valueOf();

            this.sendDataInfo.pisOrderDetail = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.orderType = 1; //orderType	订单类型0.药品订单1.器械订单
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.psomBusdept = item.depId;
                }
            });
        },
        async isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.smId = dataInfo.smId;
                        this.sendDataInfo.smName = dataInfo.smName;
                    }
                    this.sendDataInfo.salesId = "";
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
                    }
                    break;
            }
        },
        changeFocus() {
            setTimeout(() => {
                var el = document.getElementById("mainInfo");
                var inel = el.getElementsByClassName("el-input__inner");
                for (let index = 0; index < inel.length; index++) {
                    if (inel[index].value == "") {
                        inel[index].focus();
                        break;
                    }
                }
            }, 500);
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;

            this.formDataList = this.actionData.formData;
            this.filterMainField();
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.parentSearchData.smId = "";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.smId = dataInfo.smId;
                this.parentSearchData.smId = oldData.smId;
                if (this.actionData.orderType == 'UDI') {
                    this.UDIlist = oldData.depuUdiputins || []
                } else {
                    this.UDIlist = []
                }
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0;
                    setTimeout(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    }, 16.7)
                });
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                if (this.actionData.orderType == 'UDI') {
                    this.UDIlist = oldData.depuUdiputins || []
                } else {
                    this.UDIlist = []
                }
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
            this.changeFocus();
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach(item1 => {
                        if (item1.fieldType == 'number') {
                            this.$set(this.detaislDataInfo, item1.entityField, 0)
                        } else if (item1.fieldType == 'search' && item1.setField) {
                            var arr = item1.setField.split(',')
                            arr.forEach(item2 => {
                                this.$set(this.detaislDataInfo, item2, "")
                            })
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "")
                        }
                    })
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (
                        key.jurconfigform[index].isShow == 1 ||
                        key.jurconfigform[index].entityField == "sbiName" ||
                        key.jurconfigform[index].entityField == "sbiNumber"
                    )
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "pisOrderDetail" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, 'orderType', 1)//订单类型0.药品订单1.器械订单
            this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay);
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
            this.sendDataInfo.isMag = Number(this.sendDataInfo.isMag)
            this.sendDataInfo.psomBuydate = this.$moment().valueOf();
            this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
            this.sendDataInfo.psaiExptime = this.$moment().valueOf();
        },
        //确认新增
        sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.pisOrderDetail.length < 1) {
                        this.$message({
                            message: "请添加采购订单明细",
                            type: "error",
                        });
                        return;
                    }
                    var index2 = this.sendDataInfo.pisOrderDetail.findIndex(item => item.bgmId == "" || item.bgmId == null)
                    if (index2 != -1) {
                        this.sendDataInfo.pisOrderDetail.splice(index2, 1)
                    }
                    var flagNum = false
                    var flag = false
                    var indexNum = 0
                    var indexNum1 = 0
                    this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                        if ((item.psodPacknum == "" || item.psodPacknum == null || item.psodPacknum <= 0) && !flagNum) {
                            indexNum1 = index
                            flagNum = true
                        }
                        if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                        } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {

                        } else if (!flag) {
                            indexNum = index
                            flag = true
                        }
                    })
                    if (flagNum) {
                        return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum1].bgmName}数量不能为空或为零！`)
                    }
                    if (flag) {
                        return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum].bgmName}（含税价格、含税金额、价格、金额）有为零的请检查！`)
                    }
                    this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                        if (item.bgmId == "" || item.bgmId == null) {
                            this.sendDataInfo.pisOrderDetail.splice(index, 1);
                        }
                    });
                    this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length
                    if (this.actionData.orderType == "UDI") {
                        this.sendDataInfo.depuUdiputins = this.UDIlist == "" || this.UDIlist == undefined || this.UDIlist == null ? [] : this.UDIlist
                    } else {
                        this.sendDataInfo.depuUdiputins = []
                    }
                    // 使用reduce方法计算每个id的出现次数  
                    const idCounts = this.sendDataInfo.pisOrderDetail.reduce((acc, obj) => {
                        acc[obj.bgmId] = (acc[obj.bgmId] || 0) + 1;
                        return acc;
                    }, {});
                    // 过滤出出现次数超过一次的id  
                    const duplicateIds = Object.keys(idCounts).filter(id => idCounts[id] > 1);
                    if (duplicateIds.length > 0) {
                        this.$confirm("存在相同商品是否提交？", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        }).then(() => {
                            this.sub();
                        }).catch(() => { });
                    } else {
                        this.sub();
                    }
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
        },
        async sub() {
            const arr = this.sendDataInfo.pisOrderDetail.map(item => {
                return {
                    bgmId: item.bgmId,
                    psPirce: item.psprice,
                }
            })
            const res = await this.$http.woApplypriceIntercept(arr)
            if (res.status == 200) {
                this.onSub()
            } else if (res.status == 300) {
                this.$confirm("存在价格为零，是否继续保存？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.onSub()
                }).catch(() => { });
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }

        },
        async onSub() {
            this.sendDataInfo.controlGoodTempAdds = this.controlGoodTempAdds
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addPurchaseOrder(
                    this.sendDataInfo
                );
            } else {
                var responseData = await this.$http.setPurchaseOrder(
                    this.sendDataInfo
                );
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
                this.mainFormPin = []
                sessionStorage.removeItem('setPin1')
                sessionStorage.removeItem('allAndself')
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        deleteDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
                return false;
            }

            // this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            // this.selectedDetailsIndex = 0;

            this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            if (this.sendDataInfo.pisOrderDetail.length > 1) {
                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
            } else {
                this.selectedDetailsIndex = 0;
            }
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
                this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
            );
        },
        // 复制
        copyDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可复制明细",
                    type: "warning",
                });
                return false;
            } else {
                this.sendDataInfo.pisOrderDetail.push(
                    JSON.parse(
                        JSON.stringify(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        )
                    )
                );
            }
        },
        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
            if (ormInfo.isDefaultopm == 1) {
                if (info.opmBuyer == 1) {
                    this.isBuyer = 1;
                    this.sendDataInfo.depName = info.depName;
                    this.sendDataInfo.depId = info.depId;
                    this.sendDataInfo.opmName = info.opmName;
                    this.sendDataInfo.opmId = info.opmId;
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "opmName" ||
                            item.entityField == "depName"
                        )
                            item.isChange = 0;
                    });
                }
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                if (this.actionData.orderType != 'UDI') {
                    this.addDetail("sendDataInfo");
                }
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
                if (this.actionData.orderType != 'UDI') {
                    this.deleteDetails();
                }
            } else if (e.key == "F4" && this.dataActionBox.actionType != 2) {//保存
                this.sendDataAction('sendDataInfo')
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.pisOrderDetail.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.pisOrderDetail.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.checkIsBuyer();
            this.isLoaded = true;
        });
        this.$dbCache.Record_Get(4).then((res) => {
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        setTimeout(() => {
            this.getMainInput();
        }, 16.7)
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}
.dialogBox ::v-deep .el-dialog {
    margin-bottom: 0;
}
</style>